import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import translations from './useUnsavedChangesPrompt.i18n';
import { unstable_useBlocker as useBlocker } from 'react-router-dom';

/* IMPORTANT: When used on pages with back button, don't use history.goBack() as this causes a POP action that is ignored by this hook */

const useUnsavedChangesPrompt = (when: boolean) => {
  const { formatMessage } = useIntl();
  const message = formatMessage({ id: translations.message.id });
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      if (!when) {
        blocker.reset();
      } else if (confirm(message)) {
        blocker.proceed();
      }
    }
    const onNavigation = (event: BeforeUnloadEvent) => {
      if (when) {
        if (event) {
          event.returnValue = message;
        }
        return message;
      }
    };

    window.addEventListener('beforeunload', onNavigation);

    return () => {
      window.removeEventListener('beforeunload', onNavigation);
    };
  }, [message, when, blocker]);
};

export default useUnsavedChangesPrompt;
